__turbopack_context__.v({
  "bio": "miniProfile-module-scss-module__Zd0Dwq__bio",
  "close": "miniProfile-module-scss-module__Zd0Dwq__close",
  "errorBody": "miniProfile-module-scss-module__Zd0Dwq__errorBody",
  "gallery": "miniProfile-module-scss-module__Zd0Dwq__gallery",
  "header": "miniProfile-module-scss-module__Zd0Dwq__header",
  "headerOverVideo": "miniProfile-module-scss-module__Zd0Dwq__headerOverVideo",
  "identity": "miniProfile-module-scss-module__Zd0Dwq__identity",
  "instagram": "miniProfile-module-scss-module__Zd0Dwq__instagram",
  "loadingBody": "miniProfile-module-scss-module__Zd0Dwq__loadingBody",
  "loadingMedia": "miniProfile-module-scss-module__Zd0Dwq__loadingMedia",
  "metadata": "miniProfile-module-scss-module__Zd0Dwq__metadata",
  "metadataPlaceholder": "miniProfile-module-scss-module__Zd0Dwq__metadataPlaceholder",
  "more": "miniProfile-module-scss-module__Zd0Dwq__more",
  "name": "miniProfile-module-scss-module__Zd0Dwq__name",
  "nameRow": "miniProfile-module-scss-module__Zd0Dwq__nameRow",
  "photoEmpty": "miniProfile-module-scss-module__Zd0Dwq__photoEmpty",
  "photoFilters": "miniProfile-module-scss-module__Zd0Dwq__photoFilters",
  "profileFrame": "miniProfile-module-scss-module__Zd0Dwq__profileFrame",
  "scrollBody": "miniProfile-module-scss-module__Zd0Dwq__scrollBody",
  "scrollOverVideo": "miniProfile-module-scss-module__Zd0Dwq__scrollOverVideo",
  "usefulInfoTags": "miniProfile-module-scss-module__Zd0Dwq__usefulInfoTags",
  "videoBanner": "miniProfile-module-scss-module__Zd0Dwq__videoBanner",
});
